import ReportManagerCell from './component'

export default ReportManagerCell
